import {
  EXCHANGE_MAP_TYPES,
  isPreplannedRoundTripOffer,
  normalizeMapOffer
} from 'src/features/stocks/components/map/offerMapUtils'

export const canShowFinishedRoundTrip = reservation =>
  Boolean(
    reservation &&
      reservation.acceptedAt &&
      !reservation.annulledAt &&
      reservation.offer &&
      !isPreplannedRoundTripOffer(
        normalizeMapOffer(reservation.offer, EXCHANGE_MAP_TYPES.IMPORT)
      )
  )
